import { render, staticRenderFns } from "./ProjectMembersDialogTpl.vue?vue&type=template&id=6c745b81"
import script from "./ProjectMembersDialogTpl.vue?vue&type=script&lang=js"
export * from "./ProjectMembersDialogTpl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports